module.exports = __webpack_public_path__ + "img/Radxa64_128.c7a3d83a.png";